import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";
import { ImageUpload } from "@/components/admin/ImageUpload";

export const GalleryManager = ({ events, reload }) => {
  const [eventId, setEventId] = useState(events[0]?.id || "");
  const event = events.find((e) => e.id === eventId);

  const addImage = async (path) => {
    if (!path || !eventId) return;
    const form = new FormData();
    form.append("path", path);
    try {
      await api.post(`/admin/events/${eventId}/gallery`, form, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Photo added");
      reload();
    } catch { toast.error("Failed to add photo"); }
  };

  const delImage = async (imageId) => {
    try { await api.delete(`/admin/events/${eventId}/gallery/${imageId}`); toast.success("Removed"); reload(); }
    catch { toast.error("Delete failed"); }
  };

  return (
    <div data-testid="gallery-manager">
      <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-end">
        <div className="flex-1">
          <label className="caption mb-2 block">Event</label>
          <select className="input-field sm:max-w-xs" value={eventId} onChange={(e) => setEventId(e.target.value)} data-testid="gallery-event-select">
            {events.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
          </select>
        </div>
        {eventId && <ImageUpload label="Add Photo" value="" onChange={addImage} testid="gallery-upload" />}
      </div>

      {event && (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4" data-testid="gallery-manager-grid">
          {(event.gallery || []).map((img) => (
            <div key={img.id} className="group relative aspect-square overflow-hidden rounded-lg border border-[#2A2A32]">
              <img src={fileUrl(img.path)} alt="" className="h-full w-full object-cover" />
              <button onClick={() => delImage(img.id)} className="absolute right-2 top-2 rounded-md bg-black/70 p-1.5 text-red-400 opacity-0 transition-opacity group-hover:opacity-100" data-testid={`gallery-del-${img.id}`}><Trash2 size={15} /></button>
            </div>
          ))}
          {!(event.gallery || []).length && <p className="col-span-full text-sm text-zinc-500">No photos for this event yet.</p>}
        </div>
      )}
      {!events.length && <p className="text-sm text-zinc-500">Create an event first to add gallery photos.</p>}
    </div>
  );
};
